module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_ios_contacts.ad92f9131cee8d87184ad584be6ca93e.png";